import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all rolePrivileges
export const getRolePrivileges = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/role-privileges`);
    return response.data;
  } catch (error) {
    console.error("Error fetching rolePrivileges:", error.response?.data || error);
    throw error;
  }
};

// GET a single rolePrivilege
export const getRolePrivilegeById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/role-privileges/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching rolePrivilege:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new rolePrivilege
export const createRolePrivilege = async (rolePrivilegeData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/role-privileges`, rolePrivilegeData);
    return response.data;
  } catch (error) {
    console.error("Error creating rolePrivilege:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing rolePrivilege
export const updateRolePrivilege = async (id, rolePrivilegeData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/role-privileges/${id}`, rolePrivilegeData);
    return response.data;
  } catch (error) {
    console.error("Error updating rolePrivilege:", error.response?.data || error);
    throw error;
  }
};

// DELETE a rolePrivilege
export const deleteRolePrivilege = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/role-privileges/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting rolePrivilege:", error.response?.data || error);
    throw error;
  }
};

// GET all rolePrivileges by RoleId
export const getRolePrivilegesByRoleId = async (roleId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/role-privileges/by-role/${roleId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching rolePrivileges by roleId:", error.response?.data || error);
    throw error;
  }
};
